import xss from 'xss'
import * as _ from 'lodash'

export default {
  methods: {
    /**
     *
     * @param value 文字本体
     * @param kw 搜索的字
     * @param classStyle 高亮的class名
     * @returns {string|*}
     */
    highLight (value, kw = '', classStyle = 'highlight') {
      if (!value) {
        return '--'
      } else {
        value = xss(value)
      }
      if (kw) {
        if (kw instanceof Array) {
          _.forEach(kw, (item) => {
            const reg = new RegExp(item, 'gi')
            value = value.replace(reg, (txt) => {
              return `<span class="${classStyle}">${txt}</span>`
            })
          })
        } else {
          const reg = new RegExp(kw, 'gi')
          value = value.replace(reg, (txt) => {
            return `<span class="${classStyle}">${txt}</span>`
          })
        }
      }
      return value
    }
  }
}
